// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import styled, { ThemeProvider } from 'styled-components';
// import { darkTheme } from './Themes';
// import { motion } from 'framer-motion';

// import LogoComponent from "../subComponents/LogoComponent";
// import SocialIcons from "../subComponents/SocialIcons";
// import PowerButton from "../subComponents/PowerButton";
// import BigTitle from '../subComponents/BigTitle';

// const Box = styled.div`
//   background-color: ${props => props.theme.body};
//   min-height: 100vh;
//   padding: 4rem 2rem;
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   color: ${props => props.theme.text};

//   @media (max-width: 768px) {
//     padding: 3rem 1rem;
//   }
// `;

// const Content = styled(motion.div)`
//   max-width: 1000px;
//   width: 100%;
//   margin-top: 6rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;

//   img {
//     width: 100%;
//     max-height: 400px;
//     object-fit: cover;
//     border-radius: 12px;
//     margin: 1rem 0;

//     @media (max-width: 600px) {
//       max-height: 250px;
//     }
//   }

//   p {
//     margin-top: 1rem;
//     font-size: 1.1rem;
//     line-height: 1.6;

//     @media (max-width: 600px) {
//       font-size: 1rem;
//     }
//   }
// `;

// const TagList = styled.div`
//   margin: 1rem 0;

//   span {
//     margin: 0 0.5rem;
//     color: #aaa;
//     font-size: 0.9rem;
//   }
// `;

// const LinkGroup = styled.div`
//   margin: 2rem 0;
//   display: flex;
//   gap: 1.5rem;
//   flex-wrap: wrap;
//   justify-content: center;

//   a {
//     padding: 0.75rem 1.5rem;
//     border: 1px solid ${props => props.theme.text};
//     border-radius: 8px;
//     text-decoration: none;
//     color: ${props => props.theme.text};
//     transition: all 0.3s ease;

//     &:hover {
//       background-color: ${props => props.theme.text};
//       color: ${props => props.theme.body};
//     }
//   }
// `;

// const BackButton = styled.button`
//   margin-top: 2rem;
//   padding: 0.6rem 1.2rem;
//   background: none;
//   border: 1px solid ${props => props.theme.text};
//   color: ${props => props.theme.text};
//   border-radius: 6px;
//   cursor: pointer;
//   transition: all 0.3s ease;

//   &:hover {
//     background: ${props => props.theme.text};
//     color: ${props => props.theme.body};
//   }
// `;

// const pageVariants = {
//     initial: { opacity: 0, y: -30 },
//     animate: { opacity: 1, y: 0, transition: { duration: 0.6 } },
//     exit: { opacity: 0, y: 30, transition: { duration: 0.4 } },
// };

// const ProjectDetail = () => {
//     // const { id } = useParams();
//     const location = useLocation();
//     const navigate = useNavigate();
//     const project = location.state?.project;

//     if (!project) return <p style={{ padding: '2rem', color: 'white' }}>Project not found</p>;

//     const { name, description, tags, demo, github, image } = project;

//     return (
//         <ThemeProvider theme={darkTheme}>
//             <motion.div
//                 initial="initial"
//                 animate="animate"
//                 exit="exit"
//                 variants={pageVariants}
//             >
//                 <Box>
//                     <LogoComponent theme="dark" />
//                     <SocialIcons theme="dark" />
//                     <PowerButton />
//                     {/* <BigTitle text="DETAILS" top="5%" right="10%" /> */}
//                     <BigTitle text={name.toUpperCase()} top='10%' right='5%' />

//                     <Content>
//                         <h1>{name}</h1>
//                         <img src={image} alt={name} />
//                         <p>{description}</p>

//                         <TagList>
//                             {tags.map((tag, i) => (
//                                 <span key={i}>#{tag}</span>
//                             ))}
//                         </TagList>

//                         <LinkGroup>
//                             <a href={demo} target="_blank" rel="noreferrer">Live Demo</a>
//                             <a href={github} target="_blank" rel="noreferrer">Source Code</a>
//                         </LinkGroup>

//                         <BackButton onClick={() => navigate(-1)}>← Back to Work</BackButton>
//                     </Content>
//                 </Box>
//             </motion.div>
//         </ThemeProvider>
//     );
// };

// export default ProjectDetail;




import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { darkTheme } from './Themes';
import { motion } from 'framer-motion';

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";
import BigTitle from '../subComponents/BigTitle';

import { Work } from '../data/WorkData';
import { Research } from '../data/ResearchData';

const Box = styled.div`
  background-color: ${props => props.theme.body};
  min-height: 100vh;
  padding: 4rem 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.text};

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

const Content = styled(motion.div)`
  max-width: 1000px;
  width: 100%;
  margin-top: 6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 12px;
    margin: 1rem 0;

    @media (max-width: 600px) {
      max-height: 250px;
    }
  }

  p {
    margin-top: 1rem;
    font-size: 1.1rem;
    line-height: 1.6;

    @media (max-width: 600px) {
      font-size: 1rem;
    }
  }
`;

const Meta = styled.div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #aaa;
`;

const TagList = styled.div`
  margin: 1rem 0;

  span {
    margin: 0 0.5rem;
    color: #aaa;
    font-size: 0.9rem;
  }
`;

const LinkGroup = styled.div`
  margin: 2rem 0;
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;

  a {
    padding: 0.75rem 1.5rem;
    border: 1px solid ${props => props.theme.text};
    border-radius: 8px;
    text-decoration: none;
    color: ${props => props.theme.text};
    transition: all 0.3s ease;

    &:hover {
      background-color: ${props => props.theme.text};
      color: ${props => props.theme.body};
    }
  }
`;

const BackButton = styled.button`
  margin-top: 2rem;
  padding: 0.6rem 1.2rem;
  background: none;
  border: 1px solid ${props => props.theme.text};
  color: ${props => props.theme.text};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.theme.text};
    color: ${props => props.theme.body};
  }
`;

const pageVariants = {
  initial: { opacity: 0, y: -30 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  exit: { opacity: 0, y: 30, transition: { duration: 0.4 } },
};

// Links that point back into the site (e.g. "/work") aren't real demos, so skip them
const isExternal = (href) => typeof href === 'string' && /^https?:\/\//i.test(href);

const ProjectDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Use router state when coming from a card; fall back to a data lookup so
  // refreshing the page or opening a direct link still works.
  const project =
    location.state?.project ||
    Work.find(p => String(p.id) === id) ||
    Research.find(p => String(p.id) === id);

  if (!project) {
    return <p style={{ padding: '2rem', color: 'white' }}>Project not found</p>;
  }

  const {
    name, description, tags = [], image,
    type,
    venue, year, status,          // research
    paper, pdf, code, dataset,    // research
    demo, github,                 // software
  } = project;

  const isResearch = type === 'research';
  const backTab = isResearch ? 'research' : 'software';

  const links = (isResearch
    ? [
      { label: 'Paper', href: paper },
      { label: 'PDF', href: pdf },
      { label: 'Code', href: code },
      { label: 'Dataset', href: dataset },
    ]
    : [
      { label: 'Live Demo', href: demo },
      { label: 'Source Code', href: github },
    ]
  ).filter(l => isExternal(l.href));

  const metaLine = [status, venue, year].filter(Boolean).join(' · ');

  return (
    <ThemeProvider theme={darkTheme}>
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
      >
        <Box>
          <LogoComponent theme="dark" />
          <SocialIcons theme="dark" />
          <PowerButton />
          <BigTitle text={name.toUpperCase()} top="10%" right="5%" />

          <Content>
            <h1>{name}</h1>
            {isResearch && metaLine && <Meta>{metaLine}</Meta>}

            {image && <img src={image} alt={name} />}

            <p>{description}</p>

            {tags.length > 0 && (
              <TagList>
                {tags.map((tag, i) => (
                  <span key={i}>#{tag}</span>
                ))}
              </TagList>
            )}

            {links.length > 0 && (
              <LinkGroup>
                {links.map(l => (
                  <a key={l.label} href={l.href} target="_blank" rel="noreferrer">
                    {l.label}
                  </a>
                ))}
              </LinkGroup>
            )}

            <BackButton onClick={() => navigate(`/work?tab=${backTab}`)}>
              ← Back to {isResearch ? 'Research' : 'Work'}
            </BackButton>
          </Content>
        </Box>
      </motion.div>
    </ThemeProvider>
  );
};

export default ProjectDetail;